<!-- 封装全局计数器 -->
<template>
<div>
  <van-stepper
    v-bind="$attrs"
    v-on="$listeners"
    v-model="num"
    :min="min"
    :step="step"
    :max="max"
    @plus="plus"
    @minus="minus"
    @overlimit="overlimit"
    class="cc-stepper"
  />
</div>
</template>

<script>
import Vue from 'vue'
import { Stepper, Toast } from 'vant'

Vue.use(Stepper)
  .use(Toast)

export default {
  name: 'cc-stepper',
  props: {
    /**
     *  值(接收的是父组件中的val值)
     */
    value: {
      type: Number,
      default: 1
    },
    /**
     * 每次加减的大小
     */
    step: {
      type: Number,
      default: 1
    },
    /**
     * 最小值
    */
    min: {
      type: Number,
      default: 0
    },
    /**
     * 最大值
    */
    max: {
      type: Number,
      default: 0
    },
    /**
     * 判断是否是散装 0 散装 1 不散装
    */
    choose: {
      type: Number,
      default: 0
    }
  },
  components: {},

  data () {
    return {
      num: this.value
    }
  },

  computed: {
  },
  methods: {
    plus () {
      if (this.choose === 0 && this.min !== 1) {
        Toast('包装规格有误，请联系客服')
      } else {
        this.num += this.step
      }
    },
    minus () {
      if (this.choose === 0 && this.min !== 1) {
        Toast('包装规格有误，请联系客服')
      } else {
        this.num -= this.step
      }
    },
    overlimit () {
      if (this.num === this.min) {
        Toast('抱歉，最小购买量为（' + this.min + '）!')
      } else if (this.num >= this.max) {
        Toast('抱歉，已超过该商品库存量！')
      }
    }
  },
  watch: {
    value: {
      immediate: true,
      handler (newValue) {
        this.num = this.value
      }
    },
    num: {
      deep: true,
      immediate: true,
      handler (newValue) {
        this.$emit('input', this.step === 1 ? this.num : +this.num.toFixed(3))
      }
    }
  }
}
</script>
<style lang='scss' scoped>
  .cc-stepper{
    display: inline-block;
    /deep/{
      .van-stepper__minus, .van-stepper__plus,.van-stepper__input{
        margin: 0;
        background: rgba(255,255,255,1);
        border: 1px solid rgba(238,238,238,1);
        padding: 0;
        float: left;
      }
      .van-stepper__input{
        border-right: none;
        border-left: none;
        height: 28px;
        box-sizing: border-box!important;
      }
      .van-stepper__minus::after, .van-stepper__plus::after{
        // 兼容
        width: 1PX!important;
        height: 9PX!important;
      }
      .van-stepper__minus::before, .van-stepper__plus::before{
        width:9PX;
        height: 1PX;
      }
    }
  }
</style>
